import {
  BIRTHDATE_MIN,
  BIRTHDATE_REQUIRED,
  GENDER_REQUIRED,
  LOCATION_REQUIRED,
  TYPE_DATE,
} from '@/constants/MessageConstants'
import moment from 'moment'
import * as Yup from 'yup'

const EditProfileValidationSchema = Yup.object().shape({
  gender: Yup.string().required(GENDER_REQUIRED),
  location: Yup.object()
    .shape({
      description: Yup.string().required(LOCATION_REQUIRED),
      placeId: Yup.string().notRequired(),
    })
    .required(),
  birthdate: Yup.date()
    .typeError(TYPE_DATE)
    .required(BIRTHDATE_REQUIRED)
    .test('birthDate', BIRTHDATE_MIN, (value) => {
      return moment().diff(moment(value), 'years') >= 2
    }),
})

export default EditProfileValidationSchema
